import { useTranslations } from 'next-intl';

import { Button } from '@/components/atoms/Button';

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
  disabled?: boolean;
  onClick?: () => void;
}

export function PlayerPreviousButton({
  size = 'md',
  disabled = false,
  onClick = () => {},
}: Props) {
  const t = useTranslations();
  const resolveIconSize = () => {
    switch (size) {
      case 'xs':
        return 16;
      case 'sm':
        return 20;
      case 'md':
        return 24;
      case 'lg':
        return 28;
      case 'xl':
        return 32;
      case '2xl':
        return 36;
      case '3xl':
        return 40;
      default:
        return 24;
    }
  };

  return (
    <div>
      <Button
        variant="ghost"
        disabled={disabled}
        onClick={onClick}
        aria-label={t('PLAYER_PREVIOUS_TRACK')}
        className={
          'hover:fill-(--player-text-color-primary-inverted) fill-(--player-text-color-primary)'
        }
      >
        <svg
          aria-hidden="true"
          style={{ width: resolveIconSize(), height: 'auto' }}
          viewBox="0 0 20 21"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.25 4.5C5.66421 4.5 6 4.83579 6 5.25V15.75C6 16.1642 5.66421 16.5 5.25 16.5H4.75C4.33579 16.5 4 16.1642 4 15.75V5.25C4 4.83579 4.33579 4.5 4.75 4.5H5.25Z"
            style={{ fill: 'inherit' }}
          />
          <path
            d="M14.7118 5.31859C15.7111 4.70135 17 5.4202 17 6.59478V14.4053C17 15.5798 15.7111 16.2987 14.7118 15.6815L8.38899 11.7762C7.43998 11.1901 7.43998 9.80998 8.38899 9.22382L14.7118 5.31859Z"
            style={{ fill: 'inherit' }}
          />
        </svg>
      </Button>
    </div>
  );
}
